import React from 'react';
import Draggable from 'react-draggable';
import properties from '../../constants/Properties';
import { changeSlideDuration } from '../../actions/CurrentSlideActions';
import { changeZoom } from '../../actions/AudioEditorActions';
import saveManager from '../utils/SaveManager';
import videoUtils from '../utils/VideoUtils';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import playController from '../utils/PlayController';
import mouseUtils from '../utils/MouseUtils';
import platformDetection from '../utils/PlatformDetection';
import locales from "../../locales/LocalesManager";

export const SlideDurationSlider = React.createClass({
    getInitialState () {
        const step = (this.props.properties.end - this.props.properties.start) / this.props.properties.step;
        const realStep = (this.props.properties.width - this.props.properties.thumbSize) / step;

        return {
            step: realStep,
            currentSlideIndex: -1,
            isThumbOver: false,
            isThumbActive: false
        };
    },
    componentDidMount() {
        this.drawTrack();

        if (platformDetection.isTouchableDevice()) {
            this.refs.track.addEventListener('touchend', this.onTrackMouseDown);

            if (platformDetection.isChromeBook())
                this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);
        } else
            this.refs.track.addEventListener('mousedown', this.onTrackMouseDown);

        if (this.props.properties.isVideo || this.props.properties.isZoom)
            this.setInitialPosition();
    },
    onThumbMouseIn () {
        this.setState({
            isThumbOver: true
        });
    },
    onThumbMouseOut () {
        this.setState({
            isThumbOver: false
        });
    },
    drawTrack () {
        var canvas = this.refs.track;
        const lineSize = 4;
        canvas.width = this.props.properties.width;
        canvas.height = this.props.properties.height;
        var ctx = canvas.getContext('2d');

        if (this.props.properties.isVideo || this.props.properties.isZoom)
            ctx.fillStyle = '#272727';
        else
            ctx.fillStyle = properties.DURATION_SLIDER_COLOR;

        ctx.fillRect(0, canvas.height / 2 - lineSize / 2, canvas.width, lineSize);
        ctx.fill();
    },
    getCurrentStep (position) {
        const floatValue = position / this.state.step;
        const integerPart = parseInt(floatValue, 10);

        var newPosition;

        if ((floatValue - integerPart) > 0.5)
            newPosition = integerPart  + 1;
        else
            newPosition = integerPart;

        return newPosition;
    },
    getSliderPosition (position) {
        const newStep = this.getCurrentStep(position);
        return newStep * this.state.step;
    },
    getSliderValue (position) {
        const newStep = this.getCurrentStep(position);
        return this.props.properties.start + newStep * this.props.properties.step;
    },
    onTrackMouseDown (e) {
        if (playController.isPlaying)
            return;

        playController.getOldScrollPosition();

        var newPosition = mouseUtils.getLocalPosition(e, this.refs.track, false) - this.props.properties.thumbSize / 2;

        if (newPosition < 0)
            newPosition = 0;

        if (newPosition > (this.props.properties.width - this.props.properties.thumbSize))
            newPosition = this.props.properties.width - this.props.properties.thumbSize;

        const sliderPosition = this.getSliderPosition(newPosition);

        this.refs.thumb.style.left = sliderPosition + 'px';

        this.changeProperties(this.getSliderValue(newPosition));
    },
    onKeyDown(e) {
        var delta = 10;

        if (e.keyCode == 37) { // Left Key
            this.onMouseDown();

            setTimeout(function() {
                this.onMouseUp(undefined, undefined, -delta);
            }.bind(this), 10);
        } else
        if (e.keyCode == 39) { // Right Key
            this.onMouseDown();

            setTimeout(function() {
                this.onMouseUp(undefined, undefined, delta);
            }.bind(this), 10);
        }
    },
    onMouseDown() {
        if (playController.isPlaying)
            return;

        playController.getOldScrollPosition();

        var leftString = this.refs.thumb.style.left;
        var left = Number(leftString.substring(0, leftString.length - 2));

        this.setState({
            startPosition: left,
            currentPosition: left,
            isThumbActive: true
        });
    },
    checkPosition(deltaX) {
        var newPosition = (this.state.startPosition +  deltaX);
        const leftValue = 0;
        const rightValue = this.props.properties.width - this.props.properties.thumbSize;

        if (newPosition < leftValue)
            newPosition = leftValue;
        else if (newPosition > rightValue)
            newPosition = rightValue;

        const sliderPosition = this.getSliderPosition(newPosition);

        if(sliderPosition != this.state.currentPosition) {
            this.refs.thumb.style.left = sliderPosition + 'px';

            this.setState({
                currentPosition: sliderPosition
            });

            this.changeProperties(this.getSliderValue(this.state.currentPosition));
        }
    },
    onMouseMove (e, coreEvent) {
        if (playController.isPlaying)
            return;

        this.checkPosition(coreEvent.lastX);
    },
    onMouseUp (e, coreEvent, movement) {
        if (playController.isPlaying)
            return;

        if (movement)
            this.checkPosition(movement);
        else
            this.checkPosition(coreEvent.lastX);

        this.setState({
            isThumbActive: false
        });
    },
    changeProperties (newValue) {
        if (newValue == undefined)
            return;

        if (playController.isPlaying)
            return;

        saveManager.isContentChanged(true);

        if (this.props.properties.isZoom) {
            var oldZoom = audioEditorUtils.getZoomValue();
            this.props.properties.dispatch(changeZoom(newValue));
            audioEditorUtils.checkTimelineWidth(true, oldZoom, true);
            return;
        }

        if (this.props.properties.isVideo) {
            videoUtils.currentVideoVolume = newValue / 10;
        } else {
            audioEditorUtils.refreshAllSlidesRenderers = true;
            this.props.properties.dispatch(changeSlideDuration(newValue));
            saveManager.isContentChanged(true);
            audioEditorUtils.checkTimelineWidth();

            playController.updateCurrentSlideProperties();

            playController.updateScrollPosition(100, true);
        }
    },
    componentWillReceiveProps(nextProps) {
        if (this.props.properties.isVideo || this.props.properties.isZoom) {
            if (this.props.properties.currentValue != nextProps.properties.currentValue)
                setTimeout(this.setInitialPosition, 10);

            return;
        }

        if (this.state.currentSlideIndex < 0 || this.state.currentSlideIndex != nextProps.properties.currentSlideIndex || this.props.properties.slideDuration != nextProps.properties.slideDuration) {
            this.setState({
                currentSlideIndex: nextProps.properties.currentSlideIndex
            });

            setTimeout(this.setInitialPosition, 10);
        }
    },
    setInitialPosition() {
        if (this.refs.thumb) {
            if (this.props.properties.isVideo || this.props.properties.isZoom)
                this.refs.thumb.style.left = ((this.props.properties.currentValue - this.props.properties.start) * this.state.step) + 'px';
            else
                this.refs.thumb.style.left = ((this.props.properties.slideDuration - this.props.properties.start) * this.state.step) + 'px';
        }
    },
    render() {
        const localProps = this.props.properties;

        const wrapperStyle = {
            display: localProps.display,
            position: 'absolute',
            left: localProps.leftPosition,
            top: localProps.topPosition,
            width: localProps.width,
            height: localProps.height,
            overflowX: 'hidden',
            overflowY: 'hidden',
            cursor: 'default'
        };

        const backgroundStyle = {
            position: 'absolute',
            width: localProps.width,
            height: localProps.height,
            cursor: 'default'
        };

        const thumbBorderSize = 2;
        var thumbBorderColor = 'black';
        var background = 'white';

        if (localProps.isVideo || localProps.isZoom)
            thumbBorderColor = '#272727';

        if (this.state.isThumbOver == true || this.state.isThumbActive == true)
            thumbBorderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;

        if (localProps.isVideo || localProps.isZoom)
            background = thumbBorderColor;

        const thumbStyle = {
            position: 'absolute',
            width: localProps.thumbSize - 2 * thumbBorderSize,
            height: localProps.thumbSize - 2 * thumbBorderSize,
            top: localProps.height / 2 - localProps.thumbSize / 2,
            background: background,
            borderStyle: 'solid',
            borderColor: thumbBorderColor,
            borderWidth: 2,
            borderRadius: 50,
            cursor: 'default',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        return (
            <div className='slider' style={wrapperStyle}>
                <canvas className='slideDuration' ref='track' style={backgroundStyle}/>
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                    <button id="durationThumbButton" aria-label={locales.getCaption('zoomSliderThumb', 'other')} className='slideDuration' ref='thumb' style={thumbStyle} onKeyDown={this.onKeyDown} onMouseOver={this.onThumbMouseIn} onMouseOut={this.onThumbMouseOut}/>
                </Draggable>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/menus/SlideDurationSlider.js
 **/